// ================================================
// Main Entry Point for Webpack Bundle
// ================================================

// Initialize APP namespace FIRST
window.APP = window.APP || {};

// Import external libraries (previously from CDN)
import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import 'backbone.localstorage';

// Make libraries globally available IMMEDIATELY before any other imports
window.$ = window.jQuery = $;
window._ = _;
window.Backbone = Backbone;

// Import Styles (BEM version)
import '../css/styles-bem.scss';

// Import all application modules in correct order
// Note: These modules will now have access to global $, _, and Backbone

// 2. Models & Collections (must come before views)
import './app_model.js';

// 3. Views (require models to be defined)
import './views/activation.js';
import './views/languageselection.js';
import './views/index.js';
import './views/labelconfirmation.js';
import './views/labelcustomization.js';
import './views/labelpreview.js';
import './views/labelprint.js';
import './views/selectbrand.js';

// 1. App Configuration & Router (requires views to be defined)
import './app.js';

// 4. Initialize Application
document.addEventListener("DOMContentLoaded", function() {
  console.log("DOMContentLoaded event fired");
  
  // Set language attribute on body for CSS styling
  const lang = localStorage.getItem("language") || "es";
  console.log("Setting language to:", lang);
  
  document.body.setAttribute("data-lang", lang);
  console.log("data-lang attribute set:", document.body.getAttribute("data-lang"));
  
  window.app = new APP.LCRouter();
  
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.register("sw.js");
  }
});
